import { render } from "./Francais.vue?vue&type=template&id=34d4732e&scoped=true"
import script from "./Francais.vue?vue&type=script&lang=js"
export * from "./Francais.vue?vue&type=script&lang=js"

import "./Francais.vue?vue&type=style&index=0&id=34d4732e&lang=scss&scoped=true"

import exportComponent from "D:\\rober\\RobertVS\\portfolio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34d4732e"]])

export default __exports__